export class DocumentAttached {
	public tipo: string;
	public archivo: File;

	public constructor(type: string, file: File) {
		this.tipo = type;
		this.archivo = file;
	}
}
